import { useEffect, useState } from "react";
import "../../assets/css/loading.css";

/* ── Gambar dari /public/img/logo/ ── */
const LOGO_MARK = process.env.PUBLIC_URL + "/img/logo/logo-removebg.png";
const LOGO_FULL = process.env.PUBLIC_URL + "/img/logo/Full-removebg2.png";

export default function LoadingScreen({ onFinish }) {
  const [phase, setPhase] = useState("mark"); // "mark" | "exit" | "wordmark" | "done"

  useEffect(() => {
    const t1 = setTimeout(() => setPhase("exit"),     2800); // mark pulse selesai → exit
    const t2 = setTimeout(() => setPhase("wordmark"), 3400); // mark hilang → wordmark muncul
    const t3 = setTimeout(() => setPhase("done"),     4400); // semua selesai

    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  useEffect(() => {
    if (phase === "done" && onFinish) onFinish();
  }, [phase, onFinish]);

  return (
    <div className={`cl-loading${phase === "done" ? " cl-loading--out" : ""}`}>

      {/* ── Logo area ── */}
      <div className="cl-loading__logo">

        {/* Mark — tampil di phase "mark" & "exit" */}
        <img
          src={LOGO_MARK}
          alt="Codelune"
          className={[
            "cl-loading__mark",
            phase === "mark"                              ? "cl-loading__mark--pulse"  : "",
            phase === "exit"                              ? "cl-loading__mark--exit"   : "",
            phase === "wordmark" || phase === "done"      ? "cl-loading__mark--hidden" : "",
          ].join(" ")}
        />

        {/* Full wordmark — tampil di phase "wordmark" */}
        <img
          src={LOGO_FULL}
          alt="Codelune"
          className={[
            "cl-loading__full",
            phase === "wordmark" || phase === "done" ? "cl-loading__full--in" : "",
          ].join(" ")}
        />
      </div>

      {/* ── Progress bar ── */}
      <div className="cl-loading__bar">
        <div
          className={[
            "cl-loading__bar-fill",
            phase !== "mark" ? "cl-loading__bar-fill--done" : "",
          ].join(" ")}
        />
      </div>

      {/* ── Tagline ── */}
      <p className="cl-loading__tagline">Build Your Vision, Shine Like the Moon</p>

    </div>
  );
}
